exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div#allowance-select-wrapper .dataTables_wrapper {\n  padding: 0 10px !important;\n}", ""]);

// exports
